<header class="animated fadeInDown top-header" id="navbar">
    <!-- test  -->
    <!-- other html code -->
    <div class="clearfix"></div>
    <div id="skip_to_main"></div>
    <div class="mainHeader">
        <div class="container-fluid">
            <div class="row">
                <!-- <div class="col-5 col-sm-5 text-left mobilePaddingLogo">
                   <div class="mainLogo"><a href="https://www.mohfw.gov.in/" target="_blank"><img src="../../../../../assets/images/ministry-logo-png.png" class="img-fluid"></a></div>
                </div> -->
               
                <div class="col-6 col-sm-6 text-left my-auto mobilePaddingLogo">
                    <div role="banner" tabindex="0" target="_blank" aria-label="MINISTRY OF HEALTH AND FAMILY WELFARE" class="govindia">
                        <span><a href="https://www.mohfw.gov.in" target="_blank">
                            <img src="assets/images/emblem-gov.svg" alt="emblem" class="logo1"></a>
                        </span>
                        <span class="mainTitle"><a href="https://www.mohfw.gov.in" target="_blank" class="accessibility-plugin-ac">Ministry of Health and <br> Family Welfare</a>
                        </span>
                    </div>
                </div>
                <div class="col-6 col-sm-6 text-right ml-auto my-auto mobilePadding">
                   <ul class="access-navigation" role="menu">
                       <!-- <li class="accessibility-plugin-ac onlyMobile accessibilityNewStyle" role="link" tabindex="0" aria-label="Accessibility Settings">
                            <div class="accessibility">
                               <button title="Increase font size" (click)="changeFontSize($event)" id="increase-plugin-ac" [disabled]="maxFontSizeAllowed>4" class="inBtn">A +</button>
                               <button href="javascript:void(0);" title="Reset font size" (click)="changeFontSize($event)" id="normal-plugin-ac" class="inBtn">A</button>

                               <button href="javascript:void(0);" title="Decrease font size" (click)="changeFontSize($event)" id="decrease-plugin-ac" [disabled]="minFontSizeAllowed>4" class="inBtn">A - </button>
                           </div>
                       </li> -->
                       <li class="app-lang onlyMobile" tabindex="0" aria-label="Regional language" [attr.aria-label]="'Regional Languages' | translate" accesskey="l" title="{{'HEADER.Regional_Languages' | translate}}">
                           <app-language></app-language>
                       </li>

                       <!-- <li class="skip_to_main mobile-hide accessibility-plugin-ac mr-3" role="link" tabindex="0"
                           aria-label="Skip to main content">
                           <a href="#skip_to_main"
                               >{{'HEADER.Skip_To_Main_Content' |
                               translate}}</a>
                       </li> -->
                       <!-- <li class="mobile-hide" role="link" tabindex="0" aria-label="Screen Reader">
                           <button class="screenReaderBtn mr-2 ml-2" role="button" title="Screen Reader"><span
                                   class="icon-volume-2 mr-2"></span>Screen Reader</button>
                       </li> -->
                       <li class="fontsBtn mobile-hide" tabindex="0" aria-label="Increase font size">
                           <button (click)="changeFontSize($event)" id="increase-plugin-ac" [disabled]="maxFontSizeAllowed>4">A +</button>
                       </li>

                       <li class="fontsBtn mobile-hide Abtn" tabindex="0" aria-label="Reset font size">
                           <button href="javascript:void(0);" (click)="changeFontSize($event)" id="normal-plugin-ac">A</button>
                       </li>
                       <li class="fontsBtn mobile-hide marginRight15px" tabindex="0" aria-label="Decrease font size">
                           <button href="javascript:void(0);" (click)="changeFontSize($event)" id="decrease-plugin-ac" [disabled]="minFontSizeAllowed>4">A - </button>
                       </li>
                       <li class="app-lang mobile-hide" tabindex="0" aria-label="Regional language" [attr.aria-label]="'Regional Languages' | translate" accesskey="l">
                           <app-language></app-language>
                       </li>
                   </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="midCenterCol ">
        <div class="container-fluid ">
            <div class="row leftPart d-flex align-items-center">
                <!-- <div class="col-12 pr-md-0"> -->
                <div class="col-12">
                    <nav class="navbar navbar-expand-lg navbar-light">
                        <div role="banner" tabindex="0" [attr.aria-label]="'Logo' | translate" class="logoArea">
                            <a [routerLink]="'/'">
                                <div role="img" class="emblem-logo2">
                                    <img class="logo2" src="../../../../../assets/images/new-logo.svg" alt="Co-WIN" title="{{'Co-WIN' | translate}}" />
                                </div>
                            </a>
                            <!-- <span class="mobileloginbtn">
                                <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                    target="_blank" role="button" aria-pressed="true" class="yellowloginbtn">
                                    {{'HEADER.REGISTER_SIGN_IN_YOURSELF' | translate}}
                                    <span class="hinditextHide">लॉग इन करें</span>
                                </a>
                            </span> -->
                        </div>
                        <div class="noDesktop">
                            <div class="loginBtnMobile">
                                <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}" target="_blank" role="button" aria-pressed="true">
                                    {{'HEADER.REGISTER_SIGN_IN_YOURSELF' | translate}}
                                </a>
                            </div>
                        </div>

                        <div class="noMobile ml-auto">
                            <!-- Desktop nav-->
                            <div role='navigation' aria-label='Menu' class="menunavigation">
                                <ul class="menuItemCenter">
                                    <li tabindex="0" class="accessibility-plugin-ac" [attr.aria-label]="'HEADER.Vaccination_Services' | translate">
                                        <a href="https://healthid.ndhm.gov.in/" role="button" target="_blank" class="dropdwnbtn accessibility-plugin-ac newMenu abhaanchortag">ABHA
                                            <span style="text-transform: capitalize;">(Health ID)</span>
                                            <!-- <span class="tooltipDiv">
                                                <span class="abhanoteIcon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
                                                    <path id="Icon_metro-info" data-name="Icon metro-info" d="M10.008,6.975a.8.8,0,0,1,.8-.8h.531a.8.8,0,0,1,.8.8v.531a.8.8,0,0,1-.8.8h-.531a.8.8,0,0,1-.8-.8Zm3.188,7.7H8.946V13.616h1.063V10.428H8.946V9.366h3.188v4.25H13.2ZM11.071,1.928a8.5,8.5,0,1,0,8.5,8.5,8.5,8.5,0,0,0-8.5-8.5Zm0,15.406a6.906,6.906,0,1,1,6.906-6.906A6.906,6.906,0,0,1,11.071,17.334Z" transform="translate(-2.571 -1.928)" />
                                                  </svg>
                                                </span>
                                                <p class="testPara">
                                                    Health ID has now been renamed to <br>Ayushman Bharat Health Account (ABHA)
                                                </p>
                                            </span> -->
                                        </a>


                                    </li>
                                  
                                    <li tabindex="0" class="accessibility-plugin-ac" [attr.aria-label]="'HEADER.Vaccination_Services' | translate">
                                        <a href="{{urls.dashboard}}" target="_blank" role="button" class="dropdwnbtn accessibility-plugin-ac newMenu">
                                            {{'HEADER.DASHBOARD' | translate}}
                                        </a>
                                    </li>
                                    <li tabindex="0" class="accessibility-plugin-ac">
                                        <a href="{{urls.verifyCertificate}}" target="_blank" role="button" class="dropdwnbtn accessibility-plugin-ac newMenu">
                                            {{'HEADER.VERIFY_CERTIFICATE' | translate}}
                                        </a>
                                    </li>
                                    <li tabindex="0" class="accessibility-plugin-ac">
                                        <a [routerLink]="'/faq'" target="_blank" role="button" class="dropdwnbtn accessibility-plugin-ac newMenu">
                                            {{'HEADER.FAQ' | translate}}
                                        </a>
                                    </li>
                                    <li tabindex="0" class="accessibility-plugin-ac">
                                        <a href="/our-partner" target="_blank" role="button" class="dropdwnbtn accessibility-plugin-ac newMenu">
                                             {{'HEADER.Partners' | translate}}
                                        </a>
                                    </li>

                                    <!-- <li tabindex="0" [attr.aria-label]="'HEADER.Vaccination_Services' | translate">
                                        <button role="button" mat-button [matMenuTriggerFor]="vaccinationServices"
                                            class="dropdwnbtn accessibility-plugin-ac">{{'HEADER.Vaccination_Services' |
                                            translate}}<span class="icon-arrow_drop_down"></span>

                                        </button>
                                        <mat-menu #vaccinationServices="matMenu" role="listbox" tabindex="0">
                                            <ul class="dropdwnlist">
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Register_Members' | translate">
                                                    <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                                        target="_blank" role="link"
                                                        class="accessibility-plugin-ac dropdown-item">
                                                        {{'HEADER.Register_Members' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Search_Vaccination_Centers' | translate">
                                                    <a routerLink="/" fragment="Search-Vaccination-Center" role="link"
                                                        class="accessibility-plugin-ac dropdown-item">
                                                        {{'HEADER.Search_Vaccination_Centers' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Book_Vaccination_Slots' | translate">
                                                    <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        target="_blank">
                                                        {{'HEADER.Book_Vaccination_Slots' | translate}} </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Manage_Appointment' | translate">
                                                    <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        target="_blank">
                                                        {{'HEADER.Manage_Appointment' | translate}}</a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Download_Certificate' | translate">
                                                    <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        target="_blank">
                                                        {{'HEADER.Download_Certificate' | translate}}</a>
                                                </li>
                                            </ul>

                                        </mat-menu>
                                    </li> -->
                                    <!-- <li tabindex="0" [attr.aria-label]="'HEADER.Platforms' | translate">
                                        <button role="button" mat-button [matMenuTriggerFor]="platforms"
                                            class="dropdwnbtn accessibility-plugin-ac">
                                            {{'HEADER.Platforms' | translate}}<span class="icon-arrow_drop_down"></span>
                                        </button>
                                        <mat-menu #platforms="matMenu" role="listbox" tabindex="0">
                                            <ul class="dropdwnlist">
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]=" 'HEADER.Co-WIN_International' | translate">
                                                    <a href="{{urls.international}}" role="link" target="_blank"
                                                        class="accessibility-plugin-ac dropdown-item">
                                                        {{'HEADER.Co-WIN_International' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.VACCINATOR' | translate">
                                                    <a href="{{urls.webApp}}" role="link" target="_blank"
                                                        class="accessibility-plugin-ac dropdown-item">
                                                        {{'HEADER.VACCINATOR' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.DEPARTMENT_LOGIN' | translate">
                                                    <a href="{{urls.admin}}"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        target="_blank">
                                                        {{'HEADER.DEPARTMENT_LOGIN' | translate}} </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.VERIFY_CERTIFICATE' | translate">
                                                    <a href="{{urls.verifyCertificate}}"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        target="_blank">
                                                        {{'HEADER.VERIFY_CERTIFICATE' | translate}}</a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Vaccination_Statistics' | translate">
                                                    <a href="{{urls.dashboard}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        target="_blank"> {{'HEADER.Vaccination_Statistics'
                                                        | translate}}</a>
                                                </li>
                                            </ul>
                                        </mat-menu>
                                    </li> -->
                                    <!-- <li tabindex="0" [attr.aria-label]="'HEADER.Resources' | translate">
                                        <button role="button" mat-button [matMenuTriggerFor]="resources"
                                            class="dropdwnbtn accessibility-plugin-ac">
                                            {{'HEADER.Resources' | translate}}<span class="icon-arrow_drop_down"></span>
                                        </button>
                                        <mat-menu #resources="matMenu" role="listbox" tabindex="0">
                                            <ul class="dropdwnlist">
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.How_To_Get_Vaccinated' | translate">
                                                    <a href="https://prod-cdn.preprod.co-vin.in/assets/pdf/User_Guide_Citizen_registration_15%2BandPrecaution.pdf"
                                                        role="link" target="_blank"
                                                        class="accessibility-plugin-ac dropdown-item">{{'HEADER.How_To_Get_Vaccinated'
                                                        | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HOME.DOS_AND_DONTS' | translate">
                                                    <a class="accessibility-plugin-ac dropdown-item"
                                                        href="https://prod-cdn.preprod.co-vin.in/assets/pdf/{{dosDontsFileName}}"
                                                        download target="_blank">{{'HOME.DOS_AND_DONTS' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Overview' | translate">
                                                    <a class="accessibility-plugin-ac dropdown-item"
                                                        href="https://prod-cdn.preprod.co-vin.in/assets/pdf/CoWIN_Overview.pdf"
                                                        download target="_blank">{{'HEADER.Overview' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.API_GUIDELINES' | translate">
                                                    <a class="accessibility-plugin-ac dropdown-item"
                                                        href="https://prod-cdn.preprod.co-vin.in/assets/docx/CoWINAPIGuidelinesFinal.pdf"
                                                        download target="_blank">{{'HEADER.API_GUIDELINES' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.API_GUIDELINES' | translate">
                                                    <a class="accessibility-plugin-ac dropdown-item"
                                                        href="https://apisetu.gov.in/api/cowin" download
                                                        target="_blank">{{'HEADER.OPEN_APIS' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'Grievance Guidelines' | translate">
                                                    <a class="accessibility-plugin-ac dropdown-item"
                                                        href="https://prod-cdn.preprod.co-vin.in/assets/pdf/Grievance_Guidelines.pdf"
                                                        download target="_blank">{{'HEADER.Grievance_Guidelines' |
                                                        translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'Frequently Asked Questions' | translate"
                                                    tabindex="0"
                                                    [attr.aria-label]="'HOME.FREQUENTLY_ASKED_QUESTIONS' | translate">
                                                    <a [routerLink]="'/faq'"
                                                        class="accessibility-plugin-ac dropdown-item">{{'HOME.FREQUENTLY_ASKED_QUESTIONS'
                                                        | translate}}</a>
                                                </li>
                                            </ul>
                                        </mat-menu>
                                    </li> -->

                                    <!-- <li tabindex="0" [attr.aria-label]="'HEADER.Support' | translate">
                                        <button role="button" mat-button [matMenuTriggerFor]="support"
                                            class="dropdwnbtn accessibility-plugin-ac">
                                            {{'HEADER.Support' | translate}}<span class="icon-arrow_drop_down"></span>
                                        </button>
                                        <mat-menu #support="matMenu" role="listbox" tabindex="0">
                                            <ul class="dropdwnlist">
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Frequently_Asked_Questions' | translate">
                                                    <a routerLink="/faq" role="link"

                                                        class="accessibility-plugin-ac dropdown-item">
                                                        {{'HEADER.Frequently_Asked_Questions' | translate}}
                                                    </a>
                                                </li>
                                                <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Certificate_Corrections' | translate">
                                                    <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}"
                                                        role="link" target="_blank"

                                                        class="accessibility-plugin-ac dropdown-item">
                                                        {{'HEADER.Certificate_Corrections' | translate}}
                                                    </a>
                                                </li> -->
                                    <!-- <li mat-menu-item tabindex="0" [attr.aria-label]="'HEADER.Certificate_Not_Received' | translate">
                                                    <a href="{{urls.selfReg}}{{currLang != 'en' ? '?lang=' + currLang : ''}}" class="accessibility-plugin-ac dropdown-item"
                                                        role="link" target="_blank"
                                                        title="{{'HEADER.Certificate_Not_Received' | translate}}">
                                                        {{'HEADER.Certificate_Not_Received' | translate}} </a>
                                                </li>
                                                <li mat-menu-item tabindex="0" [attr.aria-label]="'HEADER.Blocked_Accounts' | translate">
                                                    <a href="{{urls.selfReg}}" target="_blank" class="accessibility-plugin-ac dropdown-item"
                                                        role="link" title="{{'HEADER.Blocked_Accounts' | translate}}">
                                                        {{'HEADER.Blocked_Accounts' | translate}} </a>
                                                </li> -->
                                    <!-- <li mat-menu-item tabindex="0"
                                                    [attr.aria-label]="'HEADER.Contactus' | translate">
                                                    <a routerLink="/" fragment="howcanweHelp"
                                                        class="accessibility-plugin-ac dropdown-item" role="link"
                                                        title="{{'HEADER.Contactus' | translate}}">
                                                        {{'HEADER.Contactus' | translate}}</a>
                                                </li> -->
                                    <!-- </ul>
                                        </mat-menu>
                                    </li> -->

                                    <li class="nav-item" tabindex="0" accesskey="r" aria-label="Login">
                                        <a class="yellowloginbtn accessibility-plugin-ac" href="{{urls.selfReg}}" target="_blank" target="_blank">{{'HEADER.REGISTER_SIGN_IN_YOURSELF'
                                            | translate}}
                                            <!-- <span *ngIf="currLang !== 'hi'">लॉग इन करें</span> -->
                                        </a>
                                    </li>

                                    <!-- <li>
                                        <div class="tabOnly newregisterBtn">
                                        <button mat-button [matMenuTriggerFor]="registerMenu">
                                            <i class="registerIcon1"></i>
                                            <i class="registerIcon2"></i>
                                            <i class="registerIcon3"></i>
                                           </button>
                                    <mat-menu #registerMenu="matMenu">
                                        <button mat-menu-item><a href="{{urls.selfReg}}" class="active accessibility-plugin-ac"
                                                aria-label=" Register / Sign In" title=" Register / Sign In"> {{'HEADER.REGISTER_SIGN_IN_YOURSELF' | translate}}</a></button>
                                    </mat-menu>
                                </div>
                                    </li> -->
                                </ul>

                                
                            </div>
                            <!-- //Desktop nav-->
                        </div>
                        <div class="noDesktop">
                            <!-- Mobile nav-->
                            <div class="navIconPan">
                                <!-- <a href="#" class="mt-2"><img src="../../../../../assets/images/search.svg"></a> -->
                                <button class="hamburgerBtn newhamburgerBtn" mat-button [matMenuTriggerFor]="mobileNav">
                                    <i class="hamburgerIcon1"></i>
                                    <i class="hamburgerIcon2"></i>
                                    <i class="hamburgerIcon3"></i>


                                </button>
                                <mat-menu #mobileNav="matMenu">
                                    <a mat-menu-item href="https://healthid.ndhm.gov.in/" target="_blank" class=" accessibility-plugin-ac link-item-top abhaanchortag">ABHA
                                    (Health ID)
                                    <span class="tooltipDiv">
                                        <img src="../../../../../assets/images/ABHA_icon.svg" class="abhanoteIcon">
                                        <p class="testPara">
                                            Health ID has now been renamed to <br>Ayushman Bharat Health Account (ABHA)
                                        </p>
                                    </span>
                                </a>
                                    <a href="{{urls.dashboard}}" target="_blank" class="link-item-top" mat-menu-item>Dashboard</a>
                                    <a href="{{urls.verifyCertificate}}" target="_blank" class="dropdwnbtn accessibility-plugin-ac link-item-top" mat-menu-item>Verify Certificate
                                        </a>
                                    <a [routerLink]="'/faq'" target="_blank" class="dropdwnbtn accessibility-plugin-ac link-item-top" mat-menu-item>FAQ's
                                        </a>
                                    <a href="/our-partner" target="_blank" class="dropdwnbtn accessibility-plugin-ac link-item-top" mat-menu-item>Partners
                                        </a>
                                    <!-- <button class="link-item-top" mat-menu-item
                                        [matMenuTriggerFor]="vaccinationServices">{{'HEADER.Vaccination_Services' |
                                        translate}}</button>
                                    <button class="link-item-top" mat-menu-item
                                        [matMenuTriggerFor]="platforms">{{'HEADER.Platforms' |
                                        translate}}</button>
                                    <button class="link-item-top" mat-menu-item
                                        [matMenuTriggerFor]="resources">{{'HEADER.Resources' |
                                        translate}}</button> -->
                                    <!-- <button class="link-item-top" mat-menu-item
                                        [matMenuTriggerFor]="support">{{'HEADER.Support' |
                                        translate}}</button> -->
                                </mat-menu>
                            </div>
                            <!-- //Mobile nav-->
                        </div>

                        <div class="tabOnly newregisterBtn">
                            <button mat-button [matMenuTriggerFor]="registerMenu">
                                <i class="registerIcon1"></i>
                                <i class="registerIcon2"></i>
                                <i class="registerIcon3"></i>
                            </button>
                            <mat-menu #registerMenu="matMenu">
                                <a mat-menu-item href="https://healthid.ndhm.gov.in/" target="_blank" class=" accessibility-plugin-ac link-item-top abhaanchortag">ABHA
                                            (Health ID)
                                            <span class="tooltipDiv">
                                                <img src="../../../../../assets/images/ABHA_icon.svg" class="abhanoteIcon">
                                                <p class="testPara">
                                                    Health ID has now been renamed to <br>Ayushman Bharat Health Account (ABHA)
                                                </p>
                                            </span>
                                        </a>
                                <a href="{{urls.dashboard}}" target="_blank" class="link-item-top" mat-menu-item>Dashboard</a>
                                <a href="{{urls.verifyCertificate}}" target="_blank" class="dropdwnbtn accessibility-plugin-ac link-item-top" mat-menu-item>Verify Certificate
                                </a>
                                <a [routerLink]="'/faq'" target="_blank" class="dropdwnbtn accessibility-plugin-ac link-item-top" mat-menu-item>FAQ's
                                </a>
                                <a href="/our-partner" target="_blank" class="dropdwnbtn accessibility-plugin-ac link-item-top" mat-menu-item>Partners
                                </a>
                                <!-- <button class="link-item-top" mat-menu-item [matMenuTriggerFor]="vaccinationServices">{{'HEADER.Vaccination_Services' |
                                    translate}}</button>
                                <button class="link-item-top" mat-menu-item [matMenuTriggerFor]="platforms">{{'HEADER.Platforms' |
                                    translate}}</button>
                                <button class="link-item-top" mat-menu-item [matMenuTriggerFor]="resources">{{'HEADER.Resources' |
                                    translate}}</button> -->
                                <!-- <button class="link-item-top" mat-menu-item
                                    [matMenuTriggerFor]="support">{{'HEADER.Support' |
                                    translate}}</button> -->
                            </mat-menu>
                        </div>
                        <div role='navigation' aria-label='Menu' class="menunavigation" style="display: none;">
                            <button role="button" aria-pressed="true" class="navbar-toggler custom-toggler" [ngClass]="{'collapsed': menuOpen}" (click)="toggleClick($event)" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01"
                                aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                            <div class="collapse navbar-collapse" [ngClass]="{'show': menuOpen}" (click)="$event.stopPropagation()" id="navbarTogglerDemo01">

                            </div>
                        </div>
                    </nav>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
    <div class="clearfix"></div>
</header>
